import {groupBy} from 'lodash';
import moment from 'moment';
import React, {useMemo, useRef} from 'react';
import {GridChildComponentProps, VariableSizeGrid} from 'react-window';
import {reverseGeocode} from 'wave-common/lib/controllers/google-maps/GeocodeController';
import {zendriveTripsList} from 'wave-common/lib/controllers/ZendriveTrip';
import useStatus from 'wave-common/lib/hooks/useStatus';
import Driver from 'wave-common/lib/models/Driver';
import ZendriveTrip from 'wave-common/lib/models/ZendriveTrip';
import Delay from '../../../components/Delay';
import {FontAwesomeV5} from '../../../components/FontAwesome';
import Spinner from '../../../components/Spinner';
import {googleApiOptions} from '../../../Constants';
import RealtimeDatabaseDataSource from '../../../data-sources/RealtimeDatabaseDataSource';
import csvFromArrayOfArrays from '../../../functions/csvFromArrayOfArrays';
import {simluateDownloadClickCsv} from '../../../functions/simulateDownloadClick';
import {unwrap} from '../../../functions/unwrap';
import useElementSize from '../../../hooks/useElementSize';

export default function DriversMileage() {
  const gridElementRef = useRef<HTMLElement>();
  const divSize = useElementSize(gridElementRef);

  const {
    isPending,
    error,
    value: data,
  } = useStatus<string[][]>(
    React as never,
    useMemo(async () => {
      // fetch zendrive trips

      const start = moment().subtract(1, 'year').toDate();
      const end = new Date();

      const trips: (ZendriveTrip & {
        driver?: Partial<Driver>;
        state?: string;
      })[] = await zendriveTripsList(start, end, RealtimeDatabaseDataSource.instance);

      // fetch drivers

      const drivers: Record<string, Partial<Driver>> = (window as any).drivers ?? {};

      for (const trip of trips) {
        trip.driver =
          drivers[trip.driverId] ??
          (drivers[trip.driverId] = (await RealtimeDatabaseDataSource.instance.read('drivers', trip.driverId))
            .value as Partial<Driver>);

        trip.state =
          trip.driver.address?.region ??
          (
            await unwrap(trip.driver?.addressCoordinatesArray, coordinates =>
              reverseGeocode(coordinates, googleApiOptions),
            )
          )?.results[0].address_components.find(component => component.types.includes('administrative_area_level_1'))
            ?.short_name;
      }

      (window as any).drivers = drivers;

      // group the data

      const groupedTrips = groupBy(trips, trip => trip.state);

      console.log(groupedTrips);

      throw new Error('Fake error');

      // const data = [
      //   ['Driver', "Driver's License Number", 'State licence issued', 'Date of birth'],
      //   ...(await Promise.all(
      //     rideshareDrivers.map(async driver => {
      //       // const applicant = await ScoopMApi.instance.fountain.applicants.child(driver.fountainApplicantId!).get();
      //       return [
      //         baseUserFormalName(driver),
      //         '?', //   applicant.data.secure_data.driver_license_number,
      //         driver.address.region ?? 'None',
      //         '?', // (await unwrap(driver.types, driverTypesDescription.userFacingValue)) ?? '',
      //       ];
      //     }),
      //   )),
      // ];
      // return data;
    }, []),
  );

  return (
    <div className="h-100 d-flex">
      <div ref={gridElementRef as never} className="flex-grow-1 overflow-auto">
        {error
          ? error.message
          : isPending
          ? 'Loading'
          : divSize &&
            (data?.length ? (
              <VariableSizeGrid
                height={divSize.height}
                width={divSize.width}
                rowCount={data.length}
                rowHeight={() => 48}
                columnCount={4}
                columnWidth={columnWidth}
                itemData={data}>
                {Cell}
              </VariableSizeGrid>
            ) : (
              'No drivers'
            ))}
      </div>

      <div className="p-2 p-md-3 border-left">
        <h4>ATL Rideshare CSV</h4>
        <p className="lead">This is used to report to ATL govt</p>
        <button
          type="button"
          onClick={() => {
            simluateDownloadClickCsv(csvFromArrayOfArrays(data!), 'ATL_Rideshare');
          }}
          className="btn btn-primary"
          disabled={isPending || !data}>
          {isPending ? (
            <Delay childrenBeforeTimeout={<FontAwesomeV5 name="file-csv" />}>
              <Spinner small />
            </Delay>
          ) : (
            <FontAwesomeV5 name="file-csv" />
          )}{' '}
          Download
        </button>
      </div>
    </div>
  );
}

function Cell({data, columnIndex, rowIndex, style}: GridChildComponentProps<string[][]>) {
  const datum = data[rowIndex][columnIndex];
  return (
    <div style={style} className="p-2 d-flex align-items-center bg-white border-right border-bottom">
      {datum}
    </div>
  );
}

function columnWidth() {
  return 250;
}
